/**
 * Constantes del feature usuarios
 */

/**
 * Longitud mínima exigida para el password al dar de alta un usuario o al
 * cambiarlo en edición (ver UsuarioForm y utils/validators.js)
 */
export const MIN_PASSWORD_LENGTH = 6;
